import { render, staticRenderFns } from "./TopicAssignment.vue?vue&type=template&id=5153571f"
import script from "./TopicAssignment.vue?vue&type=script&lang=js"
export * from "./TopicAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports